import {
  createDeliveryProfile as publicCreateDeliveryProfile,
  getDeliveryProfile as publicGetDeliveryProfile,
  updateDeliveryProfile as publicUpdateDeliveryProfile,
  deleteDeliveryProfile as publicDeleteDeliveryProfile,
  queryDeliveryProfiles as publicQueryDeliveryProfiles,
  typedQueryDeliveryProfiles as publicTypedQueryDeliveryProfiles,
  addDeliveryRegion as publicAddDeliveryRegion,
  updateDeliveryRegion as publicUpdateDeliveryRegion,
  getDeliveryProfileByDeliveryRegionId as publicGetDeliveryProfileByDeliveryRegionId,
  removeDeliveryRegion as publicRemoveDeliveryRegion,
  addDeliveryCarrier as publicAddDeliveryCarrier,
  removeDeliveryCarrier as publicRemoveDeliveryCarrier,
  updateDeliveryCarrier as publicUpdateDeliveryCarrier,
  listInstalledDeliveryCarriers as publicListInstalledDeliveryCarriers,
  getDeliveryDestinationProperties as publicGetDeliveryDestinationProperties,
  listDeliveryCarriers as publicListDeliveryCarriers,
  updateCarrierSettings as publicUpdateCarrierSettings,
  setDeliveryCarrierActiveStatus as publicSetDeliveryCarrierActiveStatus,
  updateExtendedFields as publicUpdateExtendedFields,
} from './ecom-v1-delivery-profile-delivery-profile.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  DeliveryProfileQuery,
  DeliveryProfilesQueryBuilder,
  typedQueryDeliveryProfiles as universalTypedQueryDeliveryProfiles,
} from './ecom-v1-delivery-profile-delivery-profile.universal.js';
import { onDeliveryProfileCreated as publicOnDeliveryProfileCreated } from './ecom-v1-delivery-profile-delivery-profile.public.js';
import { onDeliveryProfileDeleted as publicOnDeliveryProfileDeleted } from './ecom-v1-delivery-profile-delivery-profile.public.js';
import { onDeliveryProfileRegionAdded as publicOnDeliveryProfileRegionAdded } from './ecom-v1-delivery-profile-delivery-profile.public.js';
import { onDeliveryProfileRegionRemoved as publicOnDeliveryProfileRegionRemoved } from './ecom-v1-delivery-profile-delivery-profile.public.js';
import { onDeliveryProfileRegionUpdated as publicOnDeliveryProfileRegionUpdated } from './ecom-v1-delivery-profile-delivery-profile.public.js';
import { onDeliveryProfileUpdated as publicOnDeliveryProfileUpdated } from './ecom-v1-delivery-profile-delivery-profile.public.js';

function customQueryDeliveryProfiles(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryDeliveryProfiles(httpClient)(),
    typedQueryFunction: (query: DeliveryProfileQuery) =>
      publicTypedQueryDeliveryProfiles(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): DeliveryProfilesQueryBuilder;
  function overloadedQuery(
    query: DeliveryProfileQuery
  ): ReturnType<typeof universalTypedQueryDeliveryProfiles>;
  function overloadedQuery(query?: DeliveryProfileQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createDeliveryProfile: MaybeContext<
  BuildRESTFunction<typeof publicCreateDeliveryProfile> &
    typeof publicCreateDeliveryProfile
> = /*#__PURE__*/ createRESTModule(publicCreateDeliveryProfile);
export const getDeliveryProfile: MaybeContext<
  BuildRESTFunction<typeof publicGetDeliveryProfile> &
    typeof publicGetDeliveryProfile
> = /*#__PURE__*/ createRESTModule(publicGetDeliveryProfile);
export const updateDeliveryProfile: MaybeContext<
  BuildRESTFunction<typeof publicUpdateDeliveryProfile> &
    typeof publicUpdateDeliveryProfile
> = /*#__PURE__*/ createRESTModule(publicUpdateDeliveryProfile);
export const deleteDeliveryProfile: MaybeContext<
  BuildRESTFunction<typeof publicDeleteDeliveryProfile> &
    typeof publicDeleteDeliveryProfile
> = /*#__PURE__*/ createRESTModule(publicDeleteDeliveryProfile);
export const addDeliveryRegion: MaybeContext<
  BuildRESTFunction<typeof publicAddDeliveryRegion> &
    typeof publicAddDeliveryRegion
> = /*#__PURE__*/ createRESTModule(publicAddDeliveryRegion);
export const updateDeliveryRegion: MaybeContext<
  BuildRESTFunction<typeof publicUpdateDeliveryRegion> &
    typeof publicUpdateDeliveryRegion
> = /*#__PURE__*/ createRESTModule(publicUpdateDeliveryRegion);
export const getDeliveryProfileByDeliveryRegionId: MaybeContext<
  BuildRESTFunction<typeof publicGetDeliveryProfileByDeliveryRegionId> &
    typeof publicGetDeliveryProfileByDeliveryRegionId
> = /*#__PURE__*/ createRESTModule(publicGetDeliveryProfileByDeliveryRegionId);
export const removeDeliveryRegion: MaybeContext<
  BuildRESTFunction<typeof publicRemoveDeliveryRegion> &
    typeof publicRemoveDeliveryRegion
> = /*#__PURE__*/ createRESTModule(publicRemoveDeliveryRegion);
export const addDeliveryCarrier: MaybeContext<
  BuildRESTFunction<typeof publicAddDeliveryCarrier> &
    typeof publicAddDeliveryCarrier
> = /*#__PURE__*/ createRESTModule(publicAddDeliveryCarrier);
export const removeDeliveryCarrier: MaybeContext<
  BuildRESTFunction<typeof publicRemoveDeliveryCarrier> &
    typeof publicRemoveDeliveryCarrier
> = /*#__PURE__*/ createRESTModule(publicRemoveDeliveryCarrier);
export const updateDeliveryCarrier: MaybeContext<
  BuildRESTFunction<typeof publicUpdateDeliveryCarrier> &
    typeof publicUpdateDeliveryCarrier
> = /*#__PURE__*/ createRESTModule(publicUpdateDeliveryCarrier);
export const listInstalledDeliveryCarriers: MaybeContext<
  BuildRESTFunction<typeof publicListInstalledDeliveryCarriers> &
    typeof publicListInstalledDeliveryCarriers
> = /*#__PURE__*/ createRESTModule(publicListInstalledDeliveryCarriers);
export const getDeliveryDestinationProperties: MaybeContext<
  BuildRESTFunction<typeof publicGetDeliveryDestinationProperties> &
    typeof publicGetDeliveryDestinationProperties
> = /*#__PURE__*/ createRESTModule(publicGetDeliveryDestinationProperties);
export const listDeliveryCarriers: MaybeContext<
  BuildRESTFunction<typeof publicListDeliveryCarriers> &
    typeof publicListDeliveryCarriers
> = /*#__PURE__*/ createRESTModule(publicListDeliveryCarriers);
/** @internal */
export const updateCarrierSettings: MaybeContext<
  BuildRESTFunction<typeof publicUpdateCarrierSettings> &
    typeof publicUpdateCarrierSettings
> = /*#__PURE__*/ createRESTModule(publicUpdateCarrierSettings);
export const setDeliveryCarrierActiveStatus: MaybeContext<
  BuildRESTFunction<typeof publicSetDeliveryCarrierActiveStatus> &
    typeof publicSetDeliveryCarrierActiveStatus
> = /*#__PURE__*/ createRESTModule(publicSetDeliveryCarrierActiveStatus);
export const updateExtendedFields: MaybeContext<
  BuildRESTFunction<typeof publicUpdateExtendedFields> &
    typeof publicUpdateExtendedFields
> = /*#__PURE__*/ createRESTModule(publicUpdateExtendedFields);
export const queryDeliveryProfiles: MaybeContext<
  BuildRESTFunction<typeof customQueryDeliveryProfiles> &
    typeof customQueryDeliveryProfiles
> = /*#__PURE__*/ createRESTModule(customQueryDeliveryProfiles);
/**
 * Triggered when a delivery profile is created.
 */
export const onDeliveryProfileCreated: BuildEventDefinition<
  typeof publicOnDeliveryProfileCreated
> &
  typeof publicOnDeliveryProfileCreated = createEventModule(
  publicOnDeliveryProfileCreated
);
/**
 * Triggered when a delivery profile is deleted.
 */
export const onDeliveryProfileDeleted: BuildEventDefinition<
  typeof publicOnDeliveryProfileDeleted
> &
  typeof publicOnDeliveryProfileDeleted = createEventModule(
  publicOnDeliveryProfileDeleted
);
/**
 * Triggered when a delivery region is added to a delivery profile.
 */
export const onDeliveryProfileRegionAdded: BuildEventDefinition<
  typeof publicOnDeliveryProfileRegionAdded
> &
  typeof publicOnDeliveryProfileRegionAdded = createEventModule(
  publicOnDeliveryProfileRegionAdded
);
/**
 * Triggered when a delivery region is removed from a delivery profile.
 */
export const onDeliveryProfileRegionRemoved: BuildEventDefinition<
  typeof publicOnDeliveryProfileRegionRemoved
> &
  typeof publicOnDeliveryProfileRegionRemoved = createEventModule(
  publicOnDeliveryProfileRegionRemoved
);
/**
 * Triggered when a delivery region is updated.
 */
export const onDeliveryProfileRegionUpdated: BuildEventDefinition<
  typeof publicOnDeliveryProfileRegionUpdated
> &
  typeof publicOnDeliveryProfileRegionUpdated = createEventModule(
  publicOnDeliveryProfileRegionUpdated
);
/**
 * Triggered when a delivery profile is updated.
 */
export const onDeliveryProfileUpdated: BuildEventDefinition<
  typeof publicOnDeliveryProfileUpdated
> &
  typeof publicOnDeliveryProfileUpdated = createEventModule(
  publicOnDeliveryProfileUpdated
);

export {
  SortOrder,
  DestinationScope,
  State,
  SiteCreatedContext,
  Namespace,
  DeleteStatus,
  WebhookIdentityType,
} from './ecom-v1-delivery-profile-delivery-profile.universal.js';
export {
  DeliveryProfile,
  DeliveryRegion,
  DeliveryCarrier,
  BackupRate,
  AdditionalCharge,
  Destination,
  CreatedBy,
  CreatedByIdOneOf,
  ExtendedFields,
  DeliveryRegionAdded,
  DeliveryRegionRemoved,
  DeliveryRegionUpdated,
  CreateDeliveryProfileRequest,
  CreateDeliveryProfileResponse,
  GetDeliveryProfileRequest,
  GetDeliveryProfileResponse,
  UpdateDeliveryProfileRequest,
  UpdateDeliveryProfileResponse,
  DeleteDeliveryProfileRequest,
  DeleteDeliveryProfileResponse,
  DeleteDefaultDeliveryProfileRequest,
  DeleteDefaultDeliveryProfileResponse,
  QueryDeliveryProfilesRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryDeliveryProfilesResponse,
  CursorPagingMetadata,
  Cursors,
  AddDeliveryRegionRequest,
  AddDeliveryRegionResponse,
  UpdateDeliveryRegionRequest,
  UpdateDeliveryRegionResponse,
  GetDeliveryProfileByDeliveryRegionIdRequest,
  GetDeliveryProfileByDeliveryRegionIdResponse,
  RemoveDeliveryRegionRequest,
  RemoveDeliveryRegionResponse,
  AddDeliveryCarrierRequest,
  AddDeliveryCarrierResponse,
  RemoveDeliveryCarrierRequest,
  RemoveDeliveryCarrierResponse,
  UpdateDeliveryCarrierRequest,
  UpdateDeliveryCarrierResponse,
  ListInstalledDeliveryCarriersRequest,
  ListInstalledDeliveryCarriersResponse,
  InstalledDeliveryCarrier,
  ListDeliveryDestinationsRequest,
  ListDeliveryDestinationsResponse,
  RequiredZipcodeRequest,
  RequiredZipcodeResponse,
  GetDeliveryDestinationPropertiesRequest,
  GetDeliveryDestinationPropertiesResponse,
  DeliveryDestinationProperties,
  CountryDeliveryProperties,
  SubdivisionDeliveryProperties,
  ListDeliveryCarriersRequest,
  ListDeliveryCarriersResponse,
  ListDeliveryCarriersResult,
  ItemMetadata,
  ApplicationError,
  DeliveryCarrierDetails,
  DeliveryCarrierRegionalSettings,
  DashboardTable,
  Column,
  Row,
  BulkActionMetadata,
  UpdateCarrierSettingsRequest,
  UpdateCarrierSettingsResponse,
  SetDeliveryCarrierActiveStatusRequest,
  SetDeliveryCarrierActiveStatusResponse,
  UpdateExtendedFieldsRequest,
  UpdateExtendedFieldsResponse,
  MetaSiteSpecialEvent,
  MetaSiteSpecialEventPayloadOneOf,
  Asset,
  SiteCreated,
  SiteTransferred,
  SiteDeleted,
  DeleteContext,
  SiteUndeleted,
  SitePublished,
  SiteUnpublished,
  SiteMarkedAsTemplate,
  SiteMarkedAsWixSite,
  ServiceProvisioned,
  ServiceRemoved,
  SiteRenamed,
  SiteHardDeleted,
  NamespaceChanged,
  StudioAssigned,
  StudioUnassigned,
  SiteUrlChanged,
  SitePurgedExternally,
  OdeditorAssigned,
  OdeditorUnassigned,
  PicassoAssigned,
  PicassoUnassigned,
  WixelAssigned,
  WixelUnassigned,
  StudioTwoAssigned,
  StudioTwoUnassigned,
  UserDomainMediaEnabled,
  UserDomainMediaDisabled,
  EditorlessAssigned,
  EditorlessUnassigned,
  Empty,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  DeliveryProfileCreatedEnvelope,
  DeliveryProfileDeletedEnvelope,
  DeliveryProfileRegionAddedEnvelope,
  DeliveryProfileRegionRemovedEnvelope,
  DeliveryProfileRegionUpdatedEnvelope,
  DeliveryProfileUpdatedEnvelope,
  UpdateDeliveryProfile,
  DeliveryProfilesQueryResult,
  DeliveryProfilesQueryBuilder,
  DeliveryProfileQuerySpec,
  AddDeliveryRegionOptions,
  UpdateDeliveryRegionIdentifiers,
  UpdateDeliveryRegionOptions,
  RemoveDeliveryRegionIdentifiers,
  RemoveDeliveryRegionOptions,
  AddDeliveryCarrierOptions,
  RemoveDeliveryCarrierOptions,
  UpdateDeliveryCarrierOptions,
  ListDeliveryCarriersOptions,
  UpdateCarrierSettingsOptions,
  SetDeliveryCarrierActiveStatusOptions,
  UpdateExtendedFieldsOptions,
} from './ecom-v1-delivery-profile-delivery-profile.universal.js';
export { utils } from './ecom-v1-delivery-profile-delivery-profile.universal.js';
export {
  SortOrderWithLiterals,
  DestinationScopeWithLiterals,
  StateWithLiterals,
  SiteCreatedContextWithLiterals,
  NamespaceWithLiterals,
  DeleteStatusWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CreateDeliveryProfileApplicationErrors,
  UpdateDeliveryProfileApplicationErrors,
  AddDeliveryRegionApplicationErrors,
  AddDeliveryRegionValidationErrors,
  UpdateDeliveryRegionApplicationErrors,
  UpdateDeliveryRegionValidationErrors,
  GetDeliveryProfileByDeliveryRegionIdApplicationErrors,
  RemoveDeliveryRegionApplicationErrors,
  AddDeliveryCarrierApplicationErrors,
  AddDeliveryCarrierValidationErrors,
  RemoveDeliveryCarrierApplicationErrors,
  UpdateDeliveryCarrierApplicationErrors,
  ListDeliveryCarriersApplicationErrors,
  UpdateCarrierSettingsApplicationErrors,
  SetDeliveryCarrierActiveStatusApplicationErrors,
  CommonQueryWithEntityContext,
  DeliveryProfileQuery,
} from './ecom-v1-delivery-profile-delivery-profile.universal.js';
